import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Lector, ResponsePekingOrderWerehouse, ResponseSearchOrderWerehouse, ResponseUSer } from 'src/app/_models';
import { AuthenticationService } from 'src/app/_services';
import { environment } from 'src/environments/environment';
import { CodeBarScannerComponent } from '../modal/code-bar-scanner/code-bar-scanner.component';
import Swal from 'sweetalert2';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { NavigationEnd, Router } from '@angular/router';
import { debounceTime, filter, switchMap } from 'rxjs/operators';
import { fromEvent } from 'rxjs';
@Component({
  selector: 'app-shiptorders',
  templateUrl: './shiptorders.component.html',
  styleUrls: ['./shiptorders.component.css'],
})
export class ShiptordersComponent implements OnInit,AfterViewInit,OnDestroy {
  mySubscription: any;
  currentUser: ResponseUSer;
  datosLector: Lector;
  email = new FormControl('', [Validators.required, Validators.email]);
  datosSearch: any;
  selected = new FormControl(0);
  tab = 1;

  Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: false,
    background: ' #ffffff29',

    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    },
  });
  searchForm: FormGroup;
  FormAdd: FormGroup;

  displayedColumns: string[] = [
    'id',
    'ItemNumber',
    'Description',
    'Type',
    'Location',
    'Boxes',
    'Pieces',
    'Quantity',
    'Needed',
  ];
  dataSource: MatTableDataSource<ResponseSearchOrderWerehouse>;
  dataArraySearch: ResponseSearchOrderWerehouse[];
  @ViewChild('TableViewPaginator') paginator: MatPaginator;
  @ViewChild('TableViewSort') sort: MatSort;

//Table itemPicket

displayedColumnsAdd: string[] = [
  'id',
  'ItemNumber',
  'Description',
  'Type',
  'Location',
  
];
dataSourceadd: MatTableDataSource<ResponsePekingOrderWerehouse>;
  dataArrayadd: ResponsePekingOrderWerehouse[];
  @ViewChild('TableViewPaginatoradd') paginatoradd: MatPaginator;
  @ViewChild('TableViewSortadd') sortadd: MatSort;


  constructor(
    private formbuilder: FormBuilder,
    public dialog: MatDialog,
    private http: HttpClient,
    private authenticationService: AuthenticationService,
    private router: Router
  ) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((events) => {
      this.authenticationService.currentUser.subscribe(x => this.currentUser = x);


    });
     this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.mySubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        console.log("ddddd")
        // Trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = true;
      }
    })
  }
  ngOnDestroy(): void {
    
    if (this.mySubscription) {
      
      this.mySubscription.unsubscribe();
     
    }
    var element = document.getElementById('SubMenu');
    element.style.display = 'none';
  
    localStorage.setItem('header', '0');

  }
  ngAfterViewInit(): void {
    const main =  <HTMLInputElement>document.getElementById('SubMenu');


    fromEvent(main, 'mouseenter')
    .pipe(   
      switchMap(event => {
        console.log('show');
        main.style.display = 'block';
        return fromEvent(main, 'mouseleave').pipe(debounceTime(500));
      })
      )
    .subscribe(val => {
     console.log('hide');
     main.style.display = 'none';
   });
  }

  ngOnInit(): void {
    this.searchForm = this.formbuilder.group({
      serach: [''],
    });
    this.FormAdd = this.formbuilder.group({
      add: [''],
    });
  }

  getErrorMessage() {
    if (this.email.hasError('required')) {
      return 'You must enter a value';
    }

    return this.email.hasError('email') ? 'Not a valid email' : '';
  }
  openDialog(): void {
    const dialogRef = this.dialog.open(CodeBarScannerComponent, {
      width: '250px',
      data: this.datosLector,
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.FormAdd.controls.add.setValue(result.Resultado);
    });
  }
  openDialogSearch(): void {
    const dialogRef = this.dialog.open(CodeBarScannerComponent, {
      width: '650px',
      data: this.datosLector,
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.searchForm.controls.serach.setValue(result.Resultado);
      this.OnSearch();
    });
  }
  OnResultadoLector() {
    var json = JSON.parse(localStorage.getItem('currentUser')); //json con datos de usuario

    var Request = {};
    Request['orderid'] = Number(this.datosSearch[0].OrderId);
    Request['customerID'] = Number(this.datosSearch[0].tblCustomerID);
    Request['Barcode'] = String(this.FormAdd.controls.add.value);
    this.http
      .post<any>(
        `${environment.apiUrl}/Shipping/addItemsImsAppWerehouse`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + this.authenticationService.currentUserValue.token,
          }),
        }
      )
      .subscribe((response: any) => {
        this.Toast.fire({
          icon: 'info',
          title: response.responses,
        });
        this.OnPendigItems();
        this.OnPekingItems();
      });
  }
  OnSearch() {
    var json = JSON.parse(localStorage.getItem('currentUser')); //json con datos de usuario

    var Request = {};
    Request['companyid'] = Number(
      this.authenticationService.currentUserValue.companyIdWh
    );
    Request['textSearch'] = String(this.searchForm.controls.serach.value);

    this.http
      .post<any>(
        `${environment.apiUrl}/Shipping/SearchOrderImsAppWerehouse`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token,
          }),
        }
      )
      .subscribe((response: any) => {
        this.datosSearch = response;
        try {
          if (this.datosSearch[0].OrderId != '') {
            this.selected = new FormControl(1);
            this.tab = 0;
            this.OnPendigItems();
            this.Toast.fire({
              icon: 'success',
              title: 'Success',
            });
          }
        } catch (error) {
          this.Toast.fire({
            icon: 'info',
            title: 'barcode not result',
          });
        }
      });
  }
  OnPendigItems() {
    var json = JSON.parse(localStorage.getItem('currentUser')); //json con datos de usuario

    var Request = {};

    Request['orderId'] = Number(this.datosSearch[0].OrderId);

    this.http
      .post<any>(
        `${environment.apiUrl}/Shipping/SearchOrderItemsPendingImsAppWerehouse`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token,
          }),
        }
      )
      .subscribe((response: ResponseSearchOrderWerehouse[]) => {
        console.log(response);

        this.dataArraySearch = response;
        this.dataSource = new MatTableDataSource(this.dataArraySearch);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      });
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  applyFilter2(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceadd.filter = filterValue.trim().toLowerCase();

    if (this.dataSourceadd.paginator) {
      this.dataSourceadd.paginator.firstPage();
    }
  }

  OnPekingItems() {
    var json = JSON.parse(localStorage.getItem('currentUser')); //json con datos de usuario

    var Request = {};

    Request['orderId'] = Number(this.datosSearch[0].OrderId);

    this.http
      .post<any>(
        `${environment.apiUrl}/Shipping/SearchOrderPickedItemsImsAppWerehouse`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token,
          }),
        }
      )
      .subscribe((response: ResponsePekingOrderWerehouse[]) => {
        console.log(response);

        this.dataArrayadd = response;
        this.dataSourceadd = new MatTableDataSource(this.dataArrayadd);
        this.dataSourceadd.paginator = this.paginatoradd;
        this.dataSourceadd.sort = this.sortadd;
      });
  }
  OnCancel(){
    this.tab=1;
    this.selected=new FormControl(0);
  }
}
